import * as R from "ramda"

//tags
export const setDisplayText = (tags: any) => R.map((tag: any) => R.assoc(
    'displayText',
  `${tag.TagName} : ${tag.Value|| tag.TagNameValue}`,
  tag
  ))(tags)